import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalDismissReasons, NgbCalendar, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { ApplicationSource } from '../../business-entities/application-source';
import { AppointmentDayList } from '../../business-entities/appointment-day-list-model';
import { AppointmentList, AppointmentRequestModel, AppointmentStatusRequestModel, UpdateAppointmentStatusDisplyModel } from '../../business-entities/appointmentList-model';
import { AppointmentStatus, AppointmentStatusList, DocumentPartStatus, WorkOrderStatus } from '../../business-entities/appointmentStatus-model';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { Filter } from '../../business-entities/Filter';
import { PagerData } from '../../business-entities/PagerData';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel, SearchArrayModel } from '../../business-entities/save-advance-search-filter';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { Features } from '../../business-entities/user-role-view-model';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { AppointmentService } from '../../business-services/appointment.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { OnholdStatusChangeComponent } from '../../components/onhold-status-change/onhold-status-change.component';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { PaginationService } from '../../services/pagination.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { EditAppointmentService } from './../../business-services/edit-appointment.service';
import { AddAppointmentsComponent } from './add-appointments/add-appointments.component';
import { MultiStackPopupService } from '../../services/multi-stack-popup.service';
import { ReceptionService } from '../../business-services/reception.service';
import { DeleteWorkorderComponent } from '../../components/delete-workorder/delete-workorder.component';
import { AdminCommonService } from '../../services/admin-common.service';
import { WhatsAppLogService } from '../../business-services/whatsapp-log.service';
import { BrandType } from '../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../business-services/brand.service';
import { AppLinkService } from '../../business-services/app-link.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { AppointmentCommonService } from '../../business-services/appointment-common.service';
import { MechanicService } from '../../business-services/mechanic.service';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit, OnDestroy {
  appointmentList: AppointmentList[] = [];
  appointmentListPDF: AppointmentList[];
  features: Features[] = [];
  appointmentListExcelExportData: any[];
  appointmentstatusList: AppointmentStatus[];
  workOrderStatusList: WorkOrderStatus[];
  workOrderStatus: WorkOrderStatus[] = [];
  statusId: number = Enums.AppointmentStatus.Cancelled;
  status: AppointmentStatus[] = [];
  appointmentStatusList: AppointmentStatusList[] = [];
  documentPartStatusList: DocumentPartStatus[] = [];
  brandList: BrandViewModel[];
  appointmentDetails: AppointmentList;
  bookingDate: any[] = [];
  createdDate: any[] = [];
  appointmentSub: Subscription;
  appointmentDay: string;
  closeResult: string;
  statusList: [] = [];
  DealerName: string = null;
  SelectedStatus: any = null;
  previousStatus: any;
  InvoicePrice: any = 0;
  searchTerm: string;
  dealerList: Array<SelectListItemViewModel>;
  dealerId: string = null;
  dealerSelected: string = '';
  serviceAdvisorSelected: string = '';
  mechanicSelected: string = '';
  id: string = '0';
  contactDetails: AppointmentDetail;
  isRentalCar: boolean = false;
  needAttention: number = 0;
  toweinCars: number = 0;
  importedCar: number = 0;
  isWarrantyAppointment: number = 0;
  isWarrantyDocumentSigned: any = null;
  whatsappUnrepliedCount: number;
  currentOffer: boolean = false;
  isTireHotel: boolean = null;
  isCustomerWaiting: boolean = false;
  isCampaignService:boolean = null;
  isDisplayInvoice: boolean = false;
  isShowDMSStatus:boolean = false;
  serchfind: boolean = false;
  includeArchive: boolean = false;
  updateAppointmentStatusModel: UpdateAppointmentStatusDisplyModel = {
    WOnumber: '',
    WOstatus: null,
    WOstatusColor: '',
    WOstatusId: 0,
    appointmentStatus: '',
    appointmnetStatusColor: '',
    bookDate: '',
    customerName: '',
    dealerName: '',
    licensePlate: '',
    appointmentId: 0,
    appointmentStatusId: 0,
    jobDetails: 0,
    brandImg: '',
    model: '',
    appointmentGuid: '',
    bookDateTime: null,
    makeCode: ''
  }
  today = this.calendar.getToday();
  isAdvanceSearch: boolean = false;
  popupCloseResult = false;
  paginationSub: Subscription;
  paginationSubPDF: Subscription;
  userRoleRightsDetails: UserRoleMenu;
  licensePlateClass: string;
  currentlagSub: Subscription;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  pager: any = {};
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25
  }
  dataRows: any[] = [];
  filter: Filter = new Filter();
  filterItems: any[];
  pagedItems: any[];
  SyncList: StatusViewModel[] = [];
  selectedSync: number;
  integrationWithDMS: boolean = false;
  realtimeDmsSyncAppointment: boolean = false;
  isDeleteDmsAppointment: boolean = false;
  appointmentListCountSub: Subscription;
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Appointment,
    saveSearchArray: []
  };
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Appointment,
  };
  isAdvanceDealerSearch: boolean = false;
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  appointmentStatusRequestModel: AppointmentStatusRequestModel = {
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    mechanicId:null,
    isAuthorizedByServiceAdvisor:false,
    appointmentStatusId: null,
    workOrderStatusId: null,
    customerName: null,
    languageCode: null,
    licensePlate: null,
    mobileNumber: null,
    woNumber: null,
    appointmentType: "",
    isFilterUnRepliedMessages: false
  };
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      moduleId: Enums.ModuleNames.Appointment,
      logDate: '',
      referenceId: 0
    };
  control = new FormControl();
  isFromDashboard: boolean = false;
  throttle = 100;
  scrollDistance = 1;
  isRentalcarActive: boolean;
  appointmentDayList: AppointmentDayList[] = [];
  isCurrentAppointmentOnHold: boolean = false;
  subscription: Subscription;
  isOpenByOtherUser: boolean = false;
  isOpenByOtherUserMsg: string = "";
  isDocumentPartStatusActive: boolean = false;
  isWhatsappFeatureActive: boolean = false;
  isOfferFeatureActive: boolean = false;
  isNeedAttentionActive: boolean = false;
  isTireHotelActive: boolean = false;
  applicationSourceList: Array<SelectListItemViewModel>;
  UserList: Array<any>;
  selectedItems = [];
  selectedUser = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    searchPlaceholderText: 'Search here',
    maxHeight: 500
  };
  makeList: BrandType[] = [];
  _clientName;
  debounceTimer;
  isUserDropdown: boolean = false;
  isPlannedAndAvailableHours: boolean;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  isFilterUnRepliedMessages:boolean = false;
  isFilterApplied:boolean = false;
  _isShowCompainService:boolean = true;
  _isShowTwinCar:boolean = true;
  _isShowImportedCar:boolean = true;
  _isDmsAvailable:boolean = true;
  _isMg:boolean = false;
  serviceAdvisorList: any;
  mechanics:any;
  saveSearchDetail: SaveAdvanceSearchFilterModel | null = null;
  
  constructor(
    private readonly adminCommonService :AdminCommonService,
    private readonly appointmentService: AppointmentService,
    private readonly advanceSearchService: AdvanceSearchService,
    private readonly spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private readonly modalService: NgbModal,
    private readonly toastr: ToastrService,
    private readonly calendar: NgbCalendar,
    private readonly cookieservice: CookieService,
    private readonly translate: TranslateService,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly userService: UserDataService,
    private readonly excelService: ExcelService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly globalSetting: GlobalSetting,
    private readonly dealerService: DealerBusinessService,
    private readonly pagerService: PaginationService,
    private readonly secureStorage: SecureStorage,
    private readonly dashboardService: DashboardService,
    private readonly dmsService: DMSSyncFailedlogService,
    private readonly applicationSourceService: ApplicationSourceService,
    config: NgbModalConfig,
    private readonly _eref: ElementRef,
    private readonly cdr: ChangeDetectorRef,
    private readonly receptionService: ReceptionService,
    public datepipe: DatePipe,
    private readonly multiStackPopupService: MultiStackPopupService,
    private readonly whatsAppLogService: WhatsAppLogService,
    private readonly brandService: BrandService,
    private readonly appLinkService: AppLinkService,
    private readonly appointmentCommonService: AppointmentCommonService,
    private readonly mechanicService: MechanicService
  ) {
    this.pService.pageSize = 25;
    this.pService.searchby = ['licensePlate', 'dealerName', 'customerName', 'workOrderNo', 'mobileNo'];
    this.pService.searchTerm = '';

    config.backdrop = 'static';
    config.keyboard = false;
    this.isCurrentAppointmentOnHold = false;
  }
  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.appointmentService.appointmentRequestModel.sortColumn = column;
    this.appointmentService.appointmentRequestModel.sortDirection = direction;
    this.appointmentService.appointmentRequestModel.startRecordNumber = 0;

    this.appointmentList = [];
    await this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
  }
  async ngOnInit(): Promise<void> {
    this.getFeatures();
    var clientName = localStorage.getItem("Theme");
    if(clientName == 'bnh'){
      this._isShowCompainService = true;
      this._isShowImportedCar = true;
      this._isShowTwinCar = true;
      this._isDmsAvailable = true;
      this._isMg = false;
    }else if(clientName == 'mg'){
      this._isShowCompainService = true;
      this._isShowImportedCar = true;
      this._isShowTwinCar = true;
      this._isDmsAvailable = false;
      this._isMg = true;
    }else{
      this._isShowCompainService = false;
      this._isShowImportedCar = false;
      this._isShowTwinCar = false;
      this._isDmsAvailable = true;
      this._isMg = false;
    }
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.dealerId = this.appointmentService.appointmentRequestModel?.dealerId ? this.appointmentService.appointmentRequestModel?.dealerId : this.dealerId;
    this.appointmentService.appointmentRequestModel.startRecordNumber = 0;
    this.appointmentList = []
    if (this.dashboardService.isFromDashboard) {
      this.selectedSync = Enums.DmsSync.All;
    }
    if (this.selectedSync != undefined) {
      this.appointmentService.appointmentRequestModel.syncId = this.selectedSync;
    }
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.appointmentDay = this.appointmentService.AppointmentDay;
    this.GetAppointmentDayList();
    this.GetDealerList();
    this.GetAllMake();
    this.appointmentListCountSub = this.currentLanguageService.appointmentListCount.subscribe(x => {
      this.totalCount = x;
    })
    this.userService.currentUser.subscribe((resUser) => {
      // if (resUser.roleType === Enums.UserRoles.SuperAdmin || resUser.roleType === Enums.UserRoles.SuperUser ||
      //   resUser.roleType === Enums.UserRoles.CDSS || resUser.roleType === Enums.UserRoles.ServiceAdvisor) {
        if (this.UserList == undefined) {
          this.getCreatedByUser();
        }
        this.isUserDropdown = true;
      // }
    });
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Appointment);
    this.pService.dataSource = [];
    this.currentLanguageService.currentLanguage.subscribe((res) => {
      this.GetAllWorkOrderStatus(res);
    });
    this.multiStackPopupService.onCloseTrigger.subscribe((res) => {
      if (res) {
        this.onRefresh();
      }
    });
    this.appointmentService.appointmentRequestModel.dealerId = this.userService.currentUserValue.dealerId
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    if(this.dealerId != null && this.dealerId != undefined && this.dealerId != ''){
      await this.appointmentCommonService.getServiceAdvisorDetails(this.dealerId);
      this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
      this.cdr.detectChanges();
    }
  }

  async GetAllMake(): Promise<void> {
    this.makeList = await this.brandService.GetBrandDropdownResult();
  }

  async getCreatedByUser() {
    await this.receptionService.getCreatedByUserList(false).then((response) => {

      if(response.responseObject?.length > 0)
      {
        this.UserList = this.mapUser(response.responseObject,true);
        
      }
    })
  }

  mapUser(array: any[], singleSelection: boolean) {
    let supperArray = [];
    if (array && array.length > 0) {
      if (!singleSelection) {
        let single = Object();
        single.value = '-1'
        single.text = 'All'

        supperArray.push(single);
      }
      array.forEach(element => {
        let single = Object();
        single.value = element.userId
        single.text = element.name
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && event.target.className.indexOf('ng-option') == -1 && event.target.className.indexOf('btn') == -1 && event.target.parentElement?.className.indexOf('selected-item') == -1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        this.updateFeatureFlagValue();
      })
    }
    this.updateFeatureFlagValue();
  }

  updateFeatureFlagValue() {
    if (this.features?.length > 0) {

      //theme condition added by dharmendra tempororly until, DMS integration not completed with MG
      this.integrationWithDMS = localStorage.getItem("Theme") == 'mg'? false :  this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      let featureAppointment = localStorage.getItem("Theme") == 'mg'? false : this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive
      
      this.isDeleteDmsAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.DeleteDmsAppointment)?.isActive;
      this.isRentalcarActive = this.features.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive;
      this.isPlannedAndAvailableHours = this.features.find(x => x.featureCode === Enums.FeatureCode.PlannedAndAvailableHours)?.isActive;
      this.realtimeDmsSyncAppointment = featureAppointment;
      this.isDocumentPartStatusActive = this.features.find(x => x.featureCode === Enums.FeatureCode.DocumentPartStatus)?.isActive;
      this.isWhatsappFeatureActive = this.features.find(x => x.featureCode === Enums.FeatureCode.WhatsApp)?.isActive;
      this.isOfferFeatureActive = this.features.find(x => x.featureCode === Enums.FeatureCode.OFFER)?.isActive;
      this.isNeedAttentionActive = this.features.find(x => x.featureCode === Enums.FeatureCode.NeedAttention)?.isActive;
      this.isShowDMSStatus = this.features.find(x => x.featureCode === Enums.FeatureCode.ShowDMSStatus)?.isActive;
      this.isTireHotelActive = this.features.find(x => x.featureCode === Enums.FeatureCode.TireHotel)?.isActive;
      if (this.isWhatsappFeatureActive) {
        this.setUnRepliedWhatsAppMessagesFilter();
      }
    }
  }

  async SyncChange(status: any) {
    if (status == undefined) {
      this.isFilterApplied = false; 
      this.appointmentService.appointmentRequestModel.syncId = Enums.DmsSync.All;
    } else {
      this.isFilterApplied = true; 
      this.appointmentService.appointmentRequestModel.syncId = status;
    }
    this.appointmentService.appointmentRequestModel.startRecordNumber = 0;
    this.appointmentList = [];
    await this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
    this.GetAllWorkOrderStatus(this.appointmentService.appointmentRequestModel.languageCode);
  }

  changeRentalCarType(event: Event) {
    this.isRentalCar = (event.target as HTMLInputElement).checked;
    this.appointmentService.appointmentRequestModel.isRentalCar = this.isRentalCar ? 1 : 2;
  }

  async ChangeAppointmentDay() {
    let dateObject; let date_format;
    if (this.appointmentDay) {
      this.isFilterApplied = true; 
      this.appointmentService.AppointmentDay = this.appointmentDay;
      switch (this.appointmentDay) {
        case Enums.AppointmentDay.TodayAppointment: {
          this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          break;
        }
        case Enums.AppointmentDay.TomorrowAppointment: {
          this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          break;
        }
        case Enums.AppointmentDay.YesterdayAppointment: {
          this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() - 1));
          break;
        }
        case Enums.AppointmentDay.TodayCheckedInAppointment: {
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          this.appointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.CheckedIn;
          break;
        }
        case Enums.AppointmentDay.TomorrowCheckedInAppointment: {
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          this.appointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.CheckedIn;
          break;
        }
        case Enums.AppointmentDay.TodayNotCheckedInAppointment: {
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          this.appointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Confirmed;
          break;
        }
        case Enums.AppointmentDay.TomorrowNotCheckedInAppointment: {
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          this.appointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Confirmed;
          break;
        }
        case Enums.AppointmentDay.TodayCancelledAppointment: {
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          this.appointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Cancelled;
          break;
        }
        case Enums.AppointmentDay.TomorrowCancelledAppointment: {
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          this.appointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Cancelled;
          break;
        }
      }
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.bookingDate=[];
      this.bookingDate.push(date_format);
      this.bookingDate.push(date_format);
    }
    else {
      this.isFilterApplied = false; 
      this.appointmentService.appointmentRequestModel.bookingDate = null;
      this.bookingDate=[];
      this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
      this.appointmentService.AppointmentDay = null;
    }
    this.appointmentList = [];
    if (!this.isFromDashboard) {
      await this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
      this.GetAllWorkOrderStatus(this.appointmentService.appointmentRequestModel.languageCode);
    }
  }

  changeNeedAttention(event: Event) {
    this.needAttention = (event.target as HTMLInputElement).checked ? 1 : 0;
    this.appointmentService.appointmentRequestModel.needAttention = this.needAttention;
  }

  changeToweinCars(event: Event) {
    this.toweinCars = (event.target as HTMLInputElement).checked ? 1 : 0;
    this.appointmentService.appointmentRequestModel.toweinCars = this.toweinCars;
  }

  changeImportedCar(event: Event) {
    this.importedCar = (event.target as HTMLInputElement).checked ? 1 : 0;
    this.appointmentService.appointmentRequestModel.importedCar = this.importedCar;
  }

  changeIsWarrantyAppointment(event: Event) {
    this.isWarrantyAppointment = (event.target as HTMLInputElement).checked ? 1 : 0;
    this.appointmentService.appointmentRequestModel.isWarrantyAppointment = this.isWarrantyAppointment;
    this.isWarrantyDocumentSigned = null;
    this.appointmentService.appointmentRequestModel.isWarrantyDocumentSigned = this.isWarrantyDocumentSigned;
  }
  changeCurrentOffer(event: Event) {
    this.currentOffer = (event.target as HTMLInputElement).checked;
    this.appointmentService.appointmentRequestModel.currentOffer = this.currentOffer ? 1 : 2;
  }

  changeTireHotel(event: Event) {
    this.isTireHotel = (event.target as HTMLInputElement).checked ? true : false;
    this.appointmentService.appointmentRequestModel.isTireHotel = this.isTireHotel;
  }
  
  changeIsCustomerWaiting(event: Event) {
    this.isCustomerWaiting = (event.target as HTMLInputElement).checked;
    this.appointmentService.appointmentRequestModel.customerWaiting = this.isCustomerWaiting ? 1 : 0;
  }
  
  async setPage(pagerData: PagerData) {
    if (pagerData == null || pagerData === undefined || pagerData.page < 1 || pagerData.page > this.pager.totalPages) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
    this.appointmentService.appointmentRequestModel.startRecordNumber = (pagerData.pagerSize * (pagerData.page - 1));
    this.appointmentService.appointmentRequestModel.pageSize = pagerData.pagerSize;
    await this.GetAppointmentList(this.appointmentService.appointmentRequestModel);

  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;

    pageData.recordSize = this.totalCount;

  }
  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = (data.length === 0) ? 0 : 1;
    return this.initilisePagerFromServer(this.filter.page, Number(this.filter.pageSize), count);
  }


  initilisePagerFromServer(page: number, _pageSize: number, count: number = this.filterItems.length) {

    this.filter.pageSize = this.pagerData.pagerSize;
    this.pager = this.pagerService.getPager(count, page, this.pagerData.pagerSize);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  async GetDealerList() {
    await this.dealerService.getDealerBrandList().then(res => {
      if (res) {
        if (res.dealerList) {
          this.dealerList = this.mapdealer(res.dealerList);
        }
        this.brandList = res.brandList;
        if (this.brandList && this.brandList.length > 0) {
          this.GetAllAppointmentStatusList();
        }
      }
    })
  }

  async GetAppointmentDayList() {
    await this.appointmentService.GetAppointmentDayList().then(res => {
      if (res) {
        if (res?.responseObject) {
          this.appointmentDayList = res?.responseObject;
        }
      }
    })
  }

  mapSource(array: ApplicationSource[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.sourceId
        single.text = this._isMg && element.sourceName === 'Widget' ? 'OLB' : element.sourceName
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  mapdealer(array: DealerViewModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  async onDealerSelected(dealerId: string, flag: string) {
    this.dealerId =  dealerId ?? null;
    this.dealerSelected = this.dealerList.find(x => x.value === dealerId)?.text;
    this.appointmentService.appointmentRequestModel.dealerId = this.dealerId;
    if(dealerId?.length > 0){
      this.appointmentService.appointmentRequestModel.serviceAdvisorId = null;
      this.appointmentService.appointmentRequestModel.mechanicId = null;
      this.isFilterApplied = true; 
      await this.appointmentCommonService.getServiceAdvisorDetails(this.dealerId);
        this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
        this.cdr.detectChanges();
      await this.getAllMechanics();
    }
    else{this.isFilterApplied = false; }
    if (flag === 'dealerDropdown') {
      this.isAdvanceDealerSearch = false;
      this.appointmentService.appointmentRequestModel.startRecordNumber = 0;
      this.appointmentList = [];
      this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
      this.GetAllWorkOrderStatus(this.appointmentService.appointmentRequestModel.languageCode);
    }
    else {
      this.appointmentService.appointmentRequestModel.serviceAdvisorId = null;
      this.appointmentService.appointmentRequestModel.mechanicId = null;
      this.isAdvanceDealerSearch = true;
    }
  }


  onDownloadPDF(pdf: number) {
    this.GetAppointmentListDocument(pdf);
  }
  OpenAddAppointmentModel(): void {
    this.modalService.open(AddAppointmentsComponent, { size: 'lg', windowClass: 'pop-wid1200 pop-mh80' });
  }

  exportAsXLSX(excel: number) {
    this.GetAppointmentListDocument(excel);
  }

  onRefreshClick() {
    this.debounceFunction(() => this.onRefresh(), 500);
  }

  onRefresh() {
    this.appointmentDay = null;
    this.appointmentService.AppointmentDay = null;
    this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.appointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.bookingDate=[];
    this.createdDate = [];
    this.appointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.appointmentService.appointmentRequestModel.createdDate = null;
    this.appointmentService.appointmentRequestModel.bookingDate = null;
    this.appointmentService.appointmentRequestModel.dealerId = this.userService.currentUserValue.dealerId;
    this.appointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.appointmentService.appointmentRequestModel.mechanicId = null;
    this.appointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.appointmentService.appointmentRequestModel.customerName = null;
    this.appointmentService.appointmentRequestModel.mobileNumber = null;
    this.appointmentService.appointmentRequestModel.woNumber = null;
    this.appointmentService.appointmentRequestModel.licensePlate = null;
    this.appointmentService.appointmentRequestModel.startRecordNumber = 0;
    this.appointmentService.appointmentRequestModel.appointmentType = "";
    this.appointmentService.appointmentRequestModel.documentPartStatus = null;
    this.appointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize;
    this.dealerSelected = '';
    this.serviceAdvisorSelected = '';
    this.mechanicSelected = '';
    this.dealerId = null;
    this.appointmentService.appointmentRequestModel.isRentalCar = 2;
    this.appointmentService.appointmentRequestModel.currentOffer = 2;
    this.appointmentService.appointmentRequestModel.isTireHotel = null;

    this.appointmentService.appointmentRequestModel.customerWaiting = 0;
    this.selectedItems = [];
    this.appointmentService.appointmentRequestModel.brandCode = null;
    this.appointmentService.appointmentRequestModel.sourceOfCreation = null;
    this.appointmentList = [];
    this.isFilterApplied = false; 
    this.GetAppointmentList(this.appointmentService.appointmentRequestModel);

    let language = this.cookieservice.get('userSelectedLanguage')
    this.GetAllWorkOrderStatus(language);
  }
  onView(appointment: any) {
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }
  onSearch() {
    if (this.applicationSourceList == undefined) {
      this.GetApplicationSource();
    }

    this.isAdvanceSearch = true;
  }

  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = this.mapSource(data.responseObject).filter(source => source.value === Enums.SourceId.Planner || (this._isDmsAvailable ? source.value === Enums.SourceId.DMS : false)  || source.value === Enums.SourceId.Widget);
    });
  }

  onSourceDeselect() {
    this.isAdvanceSearch = true;
  }

  onEnterPress() {
    this.debounceFunction(() => this.onSearchFilter(), 500);
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  async onSearchFilter() {
    this.appointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber;
    this.appointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.appointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.appointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.appointmentList = [];
    try {
      if(this.searchTerm?.length >0){
        this.isFilterApplied = true;
      }
      else{
        this.isFilterApplied = false;
      }
      await this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
    }
    catch {
      this.isFilterApplied = false;
      this.spinner.hide();
    }
  }

  GetAppointmentStatusList(statusId: number, statusType: number) {
    this.pService.searchTerm = '';
    if (statusType === 1) {
      this.appointmentService.appointmentRequestModel.workOrderStatusId = null;
      if (this.appointmentService.appointmentRequestModel.appointmentStatusId === statusId) {
        this.isFilterApplied = false; 
        this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
      }
      else {
        this.isFilterApplied = true;
        this.appointmentService.appointmentRequestModel.appointmentStatusId = statusId;
      }
    }
    if (statusType === 2) {
      this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
      if (this.appointmentService.appointmentRequestModel.workOrderStatusId === statusId) {
        this.isFilterApplied = false;
        this.appointmentService.appointmentRequestModel.workOrderStatusId = null;
      }
      else {
        this.isFilterApplied = true;
        this.appointmentService.appointmentRequestModel.workOrderStatusId = statusId;
      }
    }
    this.appointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.appointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage')
    this.appointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber;
    this.appointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.pagerData.page = 1;
    this.appointmentList = [];
    this.GetAppointmentList(this.appointmentService.appointmentRequestModel);

  }
  onEdit(appointment: any) {
    this.multiStackPopupService.OpenAppointment(appointment.id, false);
  }
  DeleteAppointment(appointment: any) {
    this.spinner.show();
    this.appointmentService.IsLockedByOtherUser(appointment.appointmentGuid).then((res) => {
      const locked = res.responseObject;
      if (locked?.isLocked && this.editAppointmentService.isLockFeatureEnabled) {
        let modelHeadermsg = this.translate.instant('lblAppointmentLocked');
        let modelBodymsg = this.translate.instant('lblUsedByAnotherUser');
        modelBodymsg = modelBodymsg.replace('##USER##', locked.lockedByName);
        this.isOpenByOtherUser = true;
        const updatedModalRef = this.modalService.open(NgInfoModalContent);
        updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
        updatedModalRef.componentInstance.modelBody = modelBodymsg;
      } else {
        this.editAppointmentService.isOpenByOtherUser = false;
        let modelHeadermsg = this.translate.instant("lblDelete");
        let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblAppointment"), true);
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
          // This is intentional
        }, (reason) => {
          this.popupCloseResult = this.getDismissReason(reason);
          if (this.popupCloseResult) {

            const modalref = this.modalService.open(DeleteWorkorderComponent,
              { size: 'lg', windowClass: 'pop-wid800 ' });
            modalref.componentInstance.licensePlate = appointment.licensePlate;
            modalref.componentInstance.appointmentId = appointment.id;
            modalref.componentInstance.workOrderNumber = appointment.workOrderNo;
            modalref.componentInstance.isDeleteFromDms = this.isDeleteDmsAppointment;
            modalref.componentInstance.appointmentGuid = appointment.appointmentGuid;

            modalref.result.then((response) => {
              //status update
              if (response.success) {
                this.onRefresh();
              }
            }, _error => {
              // This is intentional
            });

            // let deleteModel ={
            //   appointmentId : appointment.id,
            //   workOrderNo : appointment.workOrderNo,
            //   licensePlate : appointment.licensePlate,
            //   userId : "",
            //   isDeleteFromDms : this.isDeleteDmsAppointment,
            //   appointmentGuid : appointment.appointmentGuid
            // }
            // this.appointmentService.DeleteAppointment(deleteModel).then((response) => {

            //   if (response.responseCode == Constant.SuccessResponseCode) {
            //     let successMsg = this.translate.instant("lblAppointmentDeleted");
            //     this.toastr.success(successMsg);
            //     this.onRefresh();
            //   }
            //   else {
            //     let errorMsg = this.translate.instant("lblAppointmentNotDeleted");
            //     this.toastr.error(errorMsg);
            //   }
            // });
          }
        });
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  GetAllAppointmentStatusList() {
    let language = this.cookieservice.get('userSelectedLanguage');
    this.spinner.show();
    this.appointmentService.GetAppointmentStatusList(language).then(data => {
      if (data?.woStatusList) {
        this.appointmentStatusList = data.woStatusList;
        this.appointmentService.appointmentStatusList = this.appointmentStatusList;
        this.documentPartStatusList = data.documentParts;

        if (this.appointmentStatusList && this.appointmentStatusList.length > 0) {
            this.currentLanguageService.currentLanguage.subscribe( x => {
            this.appointmentService.appointmentRequestModel.languageCode = x;
            this.appointmentService.appointmentRequestModel.startRecordNumber = 0;
            this.appointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize;
            this.appointmentService.appointmentRequestModel.isRentalCar = 2;
            this.appointmentService.appointmentRequestModel.currentOffer = 2;
            this.appointmentService.appointmentRequestModel.customerWaiting = this.appointmentService.appointmentRequestModel.customerWaiting ?? 0;

              this.appointmentList = [];
              if(this.appointmentDay){
                this.isFromDashboard = true;
                this.ChangeAppointmentDay();
              }
              else{
                this.isFromDashboard = false;
              }
              this.appointmentService.appointmentRequestModel.dealerId =  this.dealerId ?? '';
              this.appointmentService.appointmentRequestModel.serviceAdvisorId =  this.serviceAdvisorSelected ?? '';
              this.appointmentService.appointmentRequestModel.mechanicId =  this.mechanicSelected ?? '';
              this.GetAppointmentList(this.appointmentService.appointmentRequestModel, true);
              this.GetAllWorkOrderStatus(x);
                if (this.dealerList?.length === 1) {
                  this.onDealerSelected(this.dealerList[0].value, 'dealerDropdown');
                  this.onDealerSelected(this.dealerList[0].value, 'advanceSearchDealerDropdown');
                }
            
          }).unsubscribe();
        }
      }
      setTimeout(() => {
        this.spinner.hide();
      }, 5000);
    })
  }

  GetAllWorkOrderStatus(languageCode, fromIntialize: boolean = false) {
    this.spinner.show();
    this.appointmentStatusRequestModel.appointmentStatusId = this.appointmentService.appointmentRequestModel.appointmentStatusId;
    this.appointmentStatusRequestModel.workOrderStatusId = this.appointmentService.appointmentRequestModel.workOrderStatusId;
    this.appointmentStatusRequestModel.dealerId = this.appointmentService.appointmentRequestModel.dealerId;
    this.appointmentStatusRequestModel.languageCode = languageCode;
    this.appointmentStatusRequestModel.licensePlate = this.appointmentService.appointmentRequestModel.licensePlate;
    this.appointmentStatusRequestModel.woNumber = this.appointmentService.appointmentRequestModel.woNumber;
    this.appointmentStatusRequestModel.appointmentType = this.appointmentService.appointmentRequestModel.appointmentType;
    this.appointmentStatusRequestModel.mobileNumber = this.appointmentService.appointmentRequestModel.mobileNumber;
    this.appointmentStatusRequestModel.syncId = this.appointmentService.appointmentRequestModel.syncId
    if (fromIntialize) {
      this.appointmentStatusRequestModel.bookingDate = this.appointmentService.appointmentRequestModel.bookingDate;
    }
    else {
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
      let createdDateFormatted= this.getFormattedDate(this.createdDate);
      this.appointmentStatusRequestModel.bookingDate = bookingDateFormatted;
      this.appointmentStatusRequestModel.createdDate = createdDateFormatted;
    }
    //no need to filter the count based on workOrderStatusId & appointmentStatusId
    this.appointmentStatusRequestModel.workOrderStatusId = null;
    this.appointmentStatusRequestModel.appointmentStatusId = null;
    this.appointmentService.GetAllWorkOrderStatus(this.appointmentStatusRequestModel).then(data => {
      this.workOrderStatusList = data.responseObject.workOrderStatusList;
      this.appointmentstatusList = data.responseObject.appointmentStatusList;
    })
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    if (this.appointmentSub) {
      this.appointmentSub.unsubscribe();
    }
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.appointmentService.AppointmentDay = null
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.appointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.appointmentService.appointmentRequestModel.createdDate = null;
    this.appointmentService.appointmentRequestModel.bookingDate = null;
    this.appointmentService.appointmentRequestModel.dealerId = null;
    this.appointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.appointmentService.appointmentRequestModel.mechanicId = null;
    this.appointmentService.appointmentRequestModel.searchTerm = null;
    this.appointmentService.appointmentRequestModel.appointmentType = "";
    this.appointmentService.appointmentRequestModel.documentPartStatus = null;
  }
  getValues(){
    if (!this.isRentalCar) {
      if (this.appointmentService.appointmentRequestModel.isRentalCar === 1) {
        return 1;
      } else {
        return 2;
      }
    } else {
      if (this.isRentalCar) {
        return 1;
      } else {
        return 0;
      }
    }
  }
  AdvanceSearchSubmit() {
    this.appointmentService.appointmentRequestModel.sourceOfCreation = this.selectedItems?.map(x => x.value).join(',') ?? ""
    this.appointmentService.appointmentRequestModel.createdByUser = this.selectedUser?.map(x => x.value).join(',') ?? ""
    this.appointmentService.appointmentRequestModel.isRentalCar = this.getValues();
    this.appointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.appointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.appointmentService.appointmentRequestModel.dealerId = (this.dealerId?.length == 0 || this.dealerId == null) ? this.appointmentService.appointmentRequestModel.dealerId : this.dealerId;
    this.appointmentService.appointmentRequestModel.serviceAdvisorId = (this.serviceAdvisorSelected?.length == 0 || this.serviceAdvisorSelected == null) ? this.appointmentService.appointmentRequestModel.serviceAdvisorId : this.serviceAdvisorSelected;
    this.appointmentService.appointmentRequestModel.mechanicId = (this.mechanicSelected?.length == 0 || this.mechanicSelected == null) ? this.appointmentService.appointmentRequestModel.mechanicId : this.mechanicSelected;
    this.appointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber;
    this.appointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.appointmentService.appointmentRequestModel.currentOffer = (!this.currentOffer) ? ((this.appointmentService.appointmentRequestModel.currentOffer === 1) ? 1 : 2) : (this.currentOffer ? 1 : 0);
    this.appointmentList = [];
    this.isFilterApplied = true;
    this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
    this.GetAllWorkOrderStatus(this.appointmentService.appointmentRequestModel.languageCode);
    this.isAdvanceSearch = false;
  }
  onReset() {
    this.appointmentDay = null;
    this.isRentalCar = false;
    this.needAttention = 0;
    this.toweinCars = 0;
    this.importedCar = 0;
    this.isTireHotel = null;
    this.isWarrantyAppointment = 0;
    this.isWarrantyDocumentSigned = null;
    this.currentOffer = false;
    this.appointmentService.appointmentRequestModel.needAttention = 0;
    this.appointmentService.appointmentRequestModel.toweinCars = 0;
    this.appointmentService.appointmentRequestModel.importedCar = 0;
    this.appointmentService.appointmentRequestModel.isRentalCar = 2;
    this.appointmentService.appointmentRequestModel.isTireHotel = null;
    this.appointmentService.appointmentRequestModel.isWarrantyAppointment = 0;
    this.appointmentService.appointmentRequestModel.isWarrantyDocumentSigned = null;
    this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.appointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.bookingDate= [];
    this.createdDate = [];
    this.appointmentService.appointmentRequestModel.createdDate = null;
    this.appointmentService.appointmentRequestModel.bookingDate = null;
    this.appointmentService.appointmentRequestModel.dealerId = null;
    this.dealerId = null;
    this.serviceAdvisorSelected = null;
    this.mechanicSelected  = null;
    this.appointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.appointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
    this.appointmentService.appointmentRequestModel.mechanicId = null;
    this.appointmentService.appointmentRequestModel.customerName = null;
    this.appointmentService.appointmentRequestModel.mobileNumber = null;
    this.appointmentService.appointmentRequestModel.woNumber = null;
    this.appointmentService.appointmentRequestModel.appointmentType = "";
    this.appointmentService.appointmentRequestModel.documentPartStatus = null;
    this.appointmentService.appointmentRequestModel.licensePlate = null;
    this.appointmentService.appointmentRequestModel.currentOffer = 2;
    this.appointmentService.appointmentRequestModel.customerWaiting = 0;
    this.isCustomerWaiting = false;
    this.appointmentService.appointmentRequestModel.isCampaignService = null;
    this.appointmentList = [];
    this.selectedItems = [];
    this.appointmentService.appointmentRequestModel.brandCode = null;
    this.selectedUser = [];
    this.appointmentService.appointmentRequestModel.sourceOfCreation = null;
    this.appointmentService.appointmentRequestModel.createdByUser = null;
    this.isFilterApplied = false;
    this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
  }
  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }

  onClearFilter() {
    //for sync drop down & quick serach clear
    this.selectedSync = Enums.DmsSync.All;
    this.appointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber
    this.appointmentService.appointmentRequestModel.syncId = this.selectedSync;
    this.searchTerm = '';
    this.appointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.appointmentList = [];
    this.onReset();
    this.saveSearchDetail = null;
    this.GetAllWorkOrderStatus(this.appointmentService.appointmentRequestModel.languageCode);
  }

  onResetSaveSearch() {
    this.appointmentList = [];
    this.appointmentDay = null;
    this.isRentalCar = false;
    this.needAttention = 0;
    this.toweinCars = 0;
    this.importedCar = 0;
    this.currentOffer = false;
    this.appointmentService.appointmentRequestModel.needAttention = 0;
    this.appointmentService.appointmentRequestModel.toweinCars = 0;
    this.appointmentService.appointmentRequestModel.importedCar = 0;
    this.appointmentService.appointmentRequestModel.isRentalCar = 2;
    this.appointmentService.appointmentRequestModel.isTireHotel = null;
    this.appointmentService.appointmentRequestModel.currentOffer = 2;
    this.appointmentService.appointmentRequestModel.customerWaiting = 0;
    this.appointmentService.appointmentRequestModel.isWarrantyAppointment = 0;
    this.appointmentService.appointmentRequestModel.isWarrantyDocumentSigned = null;
    this.appointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.appointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.bookingDate= [];
    this.createdDate = [];
    this.appointmentService.appointmentRequestModel.createdDate = null;
    this.appointmentService.appointmentRequestModel.bookingDate = null;
    this.appointmentService.appointmentRequestModel.dealerId = this.userService.currentUserValue.dealerId;
    this.dealerId = null;
    this.appointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.appointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
    this.appointmentService.appointmentRequestModel.mechanicId = null;
    this.appointmentService.appointmentRequestModel.customerName = null;
    this.appointmentService.appointmentRequestModel.mobileNumber = null;
    this.appointmentService.appointmentRequestModel.woNumber = null;
    this.appointmentService.appointmentRequestModel.appointmentType = "";
    this.appointmentService.appointmentRequestModel.documentPartStatus = null;
    this.appointmentService.appointmentRequestModel.licensePlate = null;
    this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
  }
  async GetAppointmentListDocument(type) {
    this.spinner.show();
    this.appointmentService.appointmentRequestModel.isForDocuments = true;
    this.appointmentService.appointmentRequestModel.needAttention = Number(this.appointmentService.appointmentRequestModel.needAttention ? this.appointmentService.appointmentRequestModel.needAttention : 0);
    this.appointmentService.appointmentRequestModel.toweinCars = Number(this.appointmentService.appointmentRequestModel.toweinCars ? this.appointmentService.appointmentRequestModel.toweinCars : 0);
    this.appointmentService.appointmentRequestModel.importedCar = Number(this.appointmentService.appointmentRequestModel.importedCar ? this.appointmentService.appointmentRequestModel.importedCar : 0);
    await this.appointmentService.GetAppointmentList(this.appointmentService.appointmentRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        let list = response.responseObject.appointmentList;
        this.cdr.detectChanges();
        if (type === Enums.DocumentsType.Pdf) {
          this.cdr.detectChanges();
          this.AppointmentPDFDataMapper(list)
        }
        if (list && list.length > 0 && type === Enums.DocumentsType.Excel) {
          this.appointmentListExcelExportData = this.ExcelDataMapping(list);
          this.excelService.exportAsExcelFile(this.appointmentListExcelExportData, 'Appointment List');
        }
        this.appointmentService.appointmentRequestModel.isForDocuments = false;
        this.spinner.hide();
      }
    });
    this.spinner.hide()
  }

  loadMoreData(event) {
    this.debounceFunction(() => this.onScrollDown(event), 200);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.appointmentList.length) {
      this.appointmentService.appointmentRequestModel.startRecordNumber = this.appointmentList.length
      this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
    }
  }

  async GetAppointmentList(appointmentRequestModel: AppointmentRequestModel, fromIntialize: boolean = false) {
    this.spinner.show();
    this.isFromDashboard = false;
    if (fromIntialize) {
      appointmentRequestModel.bookingDate = this.appointmentService.appointmentRequestModel.bookingDate;
    }
    else {
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
      let createdDateFormatted= this.getFormattedDate(this.createdDate);
      appointmentRequestModel.bookingDate = bookingDateFormatted;
      appointmentRequestModel.createdDate = createdDateFormatted;
    }
    appointmentRequestModel.needAttention = Number(appointmentRequestModel.needAttention ?? 0);
    appointmentRequestModel.toweinCars = Number(appointmentRequestModel.toweinCars ?? 0);
    appointmentRequestModel.importedCar = Number(appointmentRequestModel.importedCar ?? 0);
    appointmentRequestModel.isFilterUnRepliedMessages = this.isFilterUnRepliedMessages;
    await this.appointmentService.GetAppointmentList(appointmentRequestModel).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        this.processSuccessfulResponse(response.responseObject.appointmentList);
      } else if (response.responseObject?.errorCount > 0 &&
        response.responseObject.result?.errorCode === Enums.ErrorCodes.ServiceCategoriesCode) {
        this.spinner.hide();
      }
      this.spinner.hide();
    });
  }

  processSuccessfulResponse(appointmentList) {
    this.appointmentList.push(...this.AppointmentDataMapper(appointmentList));
    this.totalCount = this.appointmentList.length > 0 ? this.appointmentList[0].totalCount : 0;

    const unique = [...new Set(this.appointmentList.map(item => item.dealerName))];
    this.DealerName = unique.join(", ");

    this.resetPagerData(this.supplierInitiliseGridFromServer(this.appointmentList, this.totalCount));

    if (this.pagerData.page > 1) {
      this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
    }
  }
  private AppointmentPDFDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = (this.appointmentService.appointmentRequestModel.startRecordNumber + 1) + index;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.mobileCode = element.mobileCode;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.serviceAdvisorId = element.serviceAdvisorId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime;
        single.bookedDateTime = element.bookedDateTime;
        single.isEditable = this.getEditStatusofAppointment(element.workOrderStatusId);
        single.isDeletable = this.getDeleteStatusofAppointment(element.workOrderStatusId);
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.createdTime = element.createdTime;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        supperArray.push(single);
      }
    }
    this.appointmentListPDF = supperArray;
    this.cdr.detectChanges();
    if (this.appointmentListPDF && this.appointmentListPDF.length > 0) {
      this.spinner.show();
      const doc = new jsPDF();
      autoTable(doc, { html: '#PDFdata', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 9 }, 5: { cellWidth: 25 }, 6: { cellWidth: 15 }, 8: { cellWidth: 22 } } });
      doc.save('Appointment-List.pdf');
      this.spinner.hide();
    }
  }
  private AppointmentDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = (this.appointmentService.appointmentRequestModel.startRecordNumber + 1) + index;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.mobileCode = element.mobileCode;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.serviceAdvisorId = element.serviceAdvisorId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.approvedDemand = element.approvedDemand;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.jobDetails = element.jobDetails;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime ? new Date(element.createdDateTime + 'Z') : null;
        single.bookedDateTime = element.bookedDateTime;
        single.isEditable = this.getEditStatusofAppointment(element.workOrderStatusId);
        single.isDeletable = this.getDeleteStatusofAppointment(element.workOrderStatusId);
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.createdTime = element.createdTime;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        single.sourceCreation = element.sourceCreation;
        single.unitPrice = element.unitPrice;
        single.chassisNo = element.chassisNo;
        single.totalCount = element.totalCount;
        single.isRentalCarRequired = element.isRentalCarRequired;
        single.dmsSyncStatus = element.dmsSyncStatus
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.needAttention = element.needAttention;
        single.toweinCars = element.toweinCars;
        single.importedCar = element.importedCar;
        single.includeArchive = element.includeArchive;
        single.documentPartStatus = element.documentPartStatus;
        single.currentOffer = element.currentOffer;
        single.isServiceContractVehicle = element.isServiceContractVehicle;
        single.customerGuid = element.customerGuid;
        single.isFromArchive = element.isFromArchive;
        single.isCustomerWaiting = element.isCustomerWaiting;
        single.isCampaignService = element.isCampaignService;
        single.serviceTime = Utility.toHoursAndMinutes(element.serviceTime);
        single.plannedTime = Utility.toHoursAndMinutes(element.plannedTime);
        single.userName = element.userName;
        single.allocatedTime = Utility.toHoursAndMinutes(element.allocatedTime);
        single.reasonForDeletion = element.reasonForDeletion;
        single.reasonForCancellation = element.reasonForCancellation;
        single.whatsAppUnrepliedCount = element.whatsAppUnrepliedCount;
        single.widgetAppointmentNo = element.widgetAppointmentNo;
        single.serviceAdvisorName = element.serviceAdvisorName;
        single.isAuthorizedByServiceAdvisor = element.isAuthorizedByServiceAdvisor;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  getEditStatusofAppointment(statusId: number) {
    if (this.appointmentStatusList && this.appointmentStatusList.length > 0) {
      let editable = this.appointmentStatusList.find(x => x.id === statusId);
      if (editable?.isEditable) {
        return editable.isEditable;
      }
    }
  }
  getDeleteStatusofAppointment(statusId: number) {
    if (this.appointmentStatusList && this.appointmentStatusList.length > 0) {
      let deletable = this.appointmentStatusList.find(x => x.id === statusId);
      if (deletable?.isDeletable) {
        return deletable.isDeletable;
      }
    }
  }
  getNextAvailbleStatus(appointmentStatusId, language, appointmentId) {
    this.appointmentService.GetNextAvailableStatus(appointmentStatusId, language, appointmentId).then((res) => {
      if (res.responseObject.errorCount === undefined || res.responseObject.errorCount === null) {
        this.statusList = res.responseObject;
      }
      else{
        this.statusList = null;
      }
    })
  }
  open(content, appointment) {
    this.IsLockedByOtherUser(appointment);
    this.isDisplayInvoice = false;
    this.InvoicePrice = '';
    this.GetAppointmentDetail(appointment.id);
    this.SelectedStatus = null;
    let language = this.cookieservice.get('userSelectedLanguage')
    this.getNextAvailbleStatus(appointment.workOrderStatusId, language, appointment.id)
    this.updateAppointmentStatusModel.customerName = appointment.customerName;
    this.updateAppointmentStatusModel.dealerName = appointment.dealerName;
    this.updateAppointmentStatusModel.licensePlate = appointment.licensePlate;
    this.updateAppointmentStatusModel.WOnumber = appointment.workOrderNo;
    this.updateAppointmentStatusModel.jobDetails = appointment.jobDetails;
    this.updateAppointmentStatusModel.WOstatusColor = appointment.workOrderStatusColor;
    this.updateAppointmentStatusModel.appointmentId = appointment.id;
    this.updateAppointmentStatusModel.appointmnetStatusColor = appointment.appointmentStatusColor;
    this.updateAppointmentStatusModel.bookDate = appointment.bookedDate;
    this.updateAppointmentStatusModel.WOstatusId = appointment.workOrderStatusId;
    this.updateAppointmentStatusModel.approvedDemand = appointment.approvedDemand;
    this.updateAppointmentStatusModel.WOstatus = appointment.workOrderStatus;
    this.updateAppointmentStatusModel.model = appointment.modelName;
    this.updateAppointmentStatusModel.appointmentStatusId = appointment.appointmentStatusId;
    this.updateAppointmentStatusModel.brandImg = appointment.brand;
    this.updateAppointmentStatusModel.appointmentGuid = appointment.appointmentGuid;
    this.updateAppointmentStatusModel.appointmentStatus = appointment.appointmentStatus;
    this.updateAppointmentStatusModel.bookDateTime = appointment.bookedDateTime;
    this.updateAppointmentStatusModel.appointmentType = appointment.appointmentType;
    this.updateAppointmentStatusModel.customerGuid = appointment.customerGuid;
    this.updateAppointmentStatusModel.makeCode = appointment.brandCode;
    this.isCurrentAppointmentOnHold = (appointment.workOrderStatusId === Enums.WOStatus.OnHold) ? true : false;
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  async GetAppointmentDetail(Id: number) {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.appointmentService.GetAppointmentDetail(Id, language).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.contactDetails = result.responseObject;
        this.cdr.detectChanges();
      }
      else {
        this.spinner.hide();
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }



  onStatusChange() {
     if (this.SelectedStatus != null || this.SelectedStatus != undefined) {
      if (this.SelectedStatus === Enums.WOStatus.Workdone) {
        this.GetAdditionalServiceDetail();
      }
      if (this.SelectedStatus === Enums.WOStatus.Prepared) {
        if (this.updateAppointmentStatusModel.WOstatus == Enums.WOStatusName.Cararrived) {
          let modelHeadermsg = this.translate.instant("lblChangeStatus");
          let modelBodymsg = this.translate.instant("lblSureToChangeStatus");
          modelBodymsg = modelBodymsg?.replace('{OldStatus}', this.translate.instant("lblCarArrivedstatus"));
          modelBodymsg = modelBodymsg?.replace('{NewStatus}', this.translate.instant("lblPrepared"));
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
          }, (reason) => {
            if(!reason)
            {
              this.SelectedStatus = null;
            }
          });
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.OnHold) {
        if (this.updateAppointmentStatusModel.WOstatus == Enums.WOStatusName.Mechanicdone) {
          let modelHeadermsg = this.translate.instant("lblChangeStatus");
          let modelBodymsg = this.translate.instant("lblSureToChangeStatus");
          modelBodymsg = modelBodymsg?.replace('{OldStatus}', this.translate.instant("lblMechanicDoneStatus"));
          modelBodymsg = modelBodymsg?.replace('{NewStatus}', this.translate.instant("lblOnHoldStatus"));
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
          }, (reason) => {
            if (reason) {
              this.handleOnHoldStatus();
            }
            else{
              this.SelectedStatus = null;
            }
          });
        }
        else {
          this.handleOnHoldStatus();
        }
      } else if (this.SelectedStatus === Enums.WOStatus.Cancelled) {
        this.handleCancelledStatus()
      }
      this.isDisplayInvoice = this.SelectedStatus === Enums.WOStatus.InvoicePaid;
    }
  }

  GetAdditionalServiceDetail() {
    this.appointmentService.GetAdditionalServiceDetail(this.editAppointmentService.appointmentDetails.id).then(data => {
      if (data.responseObject != null) {
        var appointmentDemandList = data.responseObject.appointmentDemandList;
        if (appointmentDemandList.length > 0) {
          var additionalDemand = appointmentDemandList.filter(x => x.demandNo > 100 && x.isAdditionalWork == true);
          if (additionalDemand.length > 0) {
            var pendingAdditionalDemand = additionalDemand.filter(x => x.isAdminApproved == 0 && x.isCustomerApporved == 0 && x.isMechanicApproved == 0 && x.isCDSSApproved == 0);
            if (pendingAdditionalDemand.length > 0) {
              let msg = this.translate.instant("lblWorkDoneStatusError");
              this.toastr.error(msg);
              this.resetCalculations();
            }
          }
        }
      }
    });
  }

  handleOnHoldStatus() {
    const modalref = this.modalService.open(OnholdStatusChangeComponent, {
      size: 'lg',
      windowClass: 'pop-wid800'
    });

    modalref.componentInstance.currentWorkorderStatusId = this.updateAppointmentStatusModel.WOstatusId;
    modalref.componentInstance.appointmentId = this.updateAppointmentStatusModel.appointmentId;
    modalref.componentInstance.workOrderNumber = this.updateAppointmentStatusModel.WOnumber;
    modalref.componentInstance.isLockedByOtherUser = this.isOpenByOtherUser;

    modalref.result.then((response) => {
      if (response.success && response.isKeepOnHold === true) {
        this.modalService.dismissAll();
        this.onRefresh();
      } else {
        this.resetCalculations();
      }
    }, _error => {
      this.onRefresh();
    });
  }

  handleCancelledStatus() {
    this.adminCommonService.openStatusChangeModal(
      this.updateAppointmentStatusModel.appointmentId,
      this.updateAppointmentStatusModel.WOnumber,
      this.isOpenByOtherUser,
      this.updateAppointmentStatusModel.appointmentType,
      this.updateAppointmentStatusModel.appointmentGuid
    ).then((response) => {
      if (response.success && response.isKeepOnHold === true) {
        this.modalService.dismissAll();
        this.onRefresh();
      } else {
        this.resetCalculations();
      }
    }, _error => {
      this.onRefresh();
    });
  }
  resetCalculations() {
    this.SelectedStatus = null;
    this.appointmentDetails.workOrderStatusId = this.previousStatus;
  }

  onBlur(event) {
    this.InvoicePrice = event.target.value;

  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  updateStatus() {
    if (this.updateAppointmentStatusModel.appointmentType == "Quote" && this.SelectedStatus == Enums.WOStatus.Cancelled) {
      // Nothing validation
    } else {
      let AddMechanicsMessage = this.translate.instant("lblAddMechanicsMessage");
      if (this.contactDetails != undefined) {
        if ((this.contactDetails.plannedMechanics == null || this.contactDetails.plannedMechanics == undefined || this.contactDetails.plannedMechanics == '') && this.SelectedStatus == Enums.WorkOrderStatus.MechanicStarted) {
          this.SelectedStatus = null;
          this.toastr.warning(AddMechanicsMessage);
          this.spinner.hide();
          return;
        }
      }
      let serviceDetails = Constant.ErrorMessageAddService;
      if (this.updateAppointmentStatusModel.jobDetails === 0) {
        this.toastr.error(serviceDetails);
        this.spinner.hide();
        return;
      }
      let ApprovedDemand = Constant.ApprovedDemand;
      if (this.updateAppointmentStatusModel.approvedDemand === 0) {
        this.toastr.error(ApprovedDemand);
        this.spinner.hide();
        return;
      }
      if (this.SelectedStatus) {
        if (this.SelectedStatus == Enums.WOStatus.InvoicePaid && this.isDisplayInvoice) {
          if (this.InvoicePrice == null || this.InvoicePrice == undefined) {
            this.toastr.error("Add amount");
            this.spinner.hide();
            return;
          }
          let regexp = new RegExp(/^[\d,.\s]+$/);
          let test = regexp.test(this.InvoicePrice);
          if (!test) {
            let msg = this.translate.instant("lblValidInputForInvoice")
            this.toastr.error(msg);
            this.spinner.hide();
            return;
          }
        }
      }
    }

    //not allow to update status for future Date
    if (this.updateAppointmentStatusModel?.appointmentGuid) {
      let viewmodel = {
        WorkOrderStatusId: this.SelectedStatus,
        AppointmentGuid: this.updateAppointmentStatusModel.appointmentGuid,
        AppointmentId: this.updateAppointmentStatusModel.appointmentId,
        IFSWorkOrderNumber: this.updateAppointmentStatusModel.WOnumber,
        ModuleId: Enums.ModuleNames.Appointment,
        IntegrationWithDMS: this.integrationWithDMS,
        realtimeDmsSyncAppointment: this.realtimeDmsSyncAppointment,
        InvoicePrice: this.globalSetting.getFormattedprice(this.InvoicePrice),
        CustomerGuid: this.updateAppointmentStatusModel.customerGuid,
        AppointmentType: this.updateAppointmentStatusModel.appointmentType,
        BrandCode: this.updateAppointmentStatusModel.makeCode
      }
      if (this.updateAppointmentStatusModel.appointmentType == "Quote" && this.SelectedStatus == Enums.WOStatus.Cancelled) {
        viewmodel.IntegrationWithDMS = false;
        viewmodel.realtimeDmsSyncAppointment = false;
      }

      this.spinner.show()
      this.appointmentService.UpdateAppointmentStatus(viewmodel).then((res) => {
        this.spinner.hide();
        if (res.responseObject?.isSuccess) {
          if(!this.empty(res.responseObject.resultMessage)){
            this.toastr.success(res.responseObject.resultMessage);
          }
          if (viewmodel.WorkOrderStatusId === Enums.WOStatus.Prepared) {
            this.appLinkService.GetCheckInUrl(viewmodel.AppointmentGuid);
          }
          if (this.saveSearchDetail) {
            this.ApplySaveSearch(this.saveSearchDetail.filterName, true);
          }else{
            this.onRefresh();
          }

          if (this.isCurrentAppointmentOnHold && viewmodel.WorkOrderStatusId !== Enums.WOStatus.Cancelled) {
            let msg = this.translate.instant("lblRescheduleAppointmentMessage")
            msg += this.updateAppointmentStatusModel.WOnumber;
            let modelHeadermsg = this.translate.instant("lblActivateWorkOrder");
            const modalRef = this.modalService.open(NgInfoModalContent);
            modalRef.componentInstance.modelHeader = modelHeadermsg;
            modalRef.componentInstance.modelBody = msg;
            modalRef.result.then((_result) => {
              // This is intentional
            }, (reason) => {
              this.popupCloseResult = this.getDismissReason(reason);
            });
          }
        }
        else if (this.isDisplayInvoice) {
          let msg = this.translate.instant("lblInputPeiceNotSameAsFinalPrice")
          this.toastr.error(msg)
        }
        else {
          this.toastr.error(res.responseObject.resultMessage)
          this.onRefresh();
        }
      })
      document.getElementById("modelButton").click();

    }

  }
  public generateStatusTrackerLink(appointmentGuid) {
    let model = {
      AppointmentGuid: appointmentGuid
    };
    this.appLinkService.AddTrackerLink(model)
      .then(
        res => {

          console.info('HTTP response successfully.', res);
        },
        err => {
          console.error('HTTP Error', err);
        }
      );
  }
  private ExcelDataMapping(appointmentList: any) {
    let supperArray = [];
    if (appointmentList && appointmentList.length > 0) {
      for (let index = 0; index < appointmentList.length; index++) {
        const element = appointmentList[index];
        let single = Object();
        single.SrNo = this.currentPageNumber(index);
        single.Type = element.appointmentType;
        single.LicensePlate = element.licensePlate;
        single.ModelName = element.modelName;
        single.BrandName = element.brandName;
        single.DealerName = element.dealerName;
        single.CustomerName = element.customerName;
        single.MobileNumber = element.mobileCode ? '+' + element.mobileCode + element.mobileNo : element.mobileNo;
        single.WoNo = element.workOrderNo;
        single.WoStatus = element.workOrderStatus;
        single.BookedDate = element.bookedDate;
        single.CreatedDate = element.createdDate;
        this.appointmentstatusList.forEach(ele => {
          if (ele.id === element.appointmentStatusId) {
            single.Status = ele.name;
          }
        })
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  /**
 * Methid to generate auto row number based on per page size
 * @param cIndex
 */
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }

  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toastr.error(ErrorMsg);
    }
  }

  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;
    this.appointmentService.appointmentRequestModel.sourceOfCreation = "";
    this.appointmentService.appointmentRequestModel.createdByUser = "";
    if (this.selectedItems.length > 0) {
      this.appointmentService.appointmentRequestModel.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    if (this.UserList.length > 0) {
      this.appointmentService.appointmentRequestModel.createdByUser = this.selectedUser.map(x => x.value).join(',');
    }
    let searchModel: SearchArrayModel =
    {
      searchColumnName: "lblIsRentalCar",
      searchValue: (this.appointmentService.appointmentRequestModel.isRentalCar === 1) ? "True" : "False",
      searchActualValue: (this.appointmentService.appointmentRequestModel.isRentalCar === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);
    searchModel =
    {
      searchColumnName: "lblCurrentOffer",
      searchValue: (this.appointmentService.appointmentRequestModel.currentOffer === 1) ? "True" : "False",
      searchActualValue: (this.appointmentService.appointmentRequestModel.currentOffer === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);
    searchModel =
    {
      searchColumnName: "lblCustomerWaiting",
      searchValue: (this.appointmentService.appointmentRequestModel.customerWaiting === 1) ? "True" : "False",
      searchActualValue: (this.appointmentService.appointmentRequestModel.customerWaiting === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);

    if(this._isShowCompainService)
    {
      searchModel =
      {
        searchColumnName: "lblCampaignService",
        searchValue: this.appointmentService.appointmentRequestModel.isCampaignService ? "True" : "False",
        searchActualValue: this.appointmentService.appointmentRequestModel.isCampaignService ? "True" : "False",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    
    if(this.isNeedAttentionActive){
      searchModel =
      {
        searchColumnName: "lblNeedAttention",
        searchValue: (this.appointmentService.appointmentRequestModel.needAttention === 1) ? "True" : "False",
        searchActualValue: (this.appointmentService.appointmentRequestModel.needAttention === 1) ? "True" : "False",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    searchModel =
    {
      searchColumnName: "lblToweinCars",
      searchValue: (this.appointmentService.appointmentRequestModel.toweinCars === 1) ? "True" : "False",
      searchActualValue: (this.appointmentService.appointmentRequestModel.toweinCars === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);

    searchModel =
    {
      searchColumnName: "lblImportedCar",
      searchValue: (this.appointmentService.appointmentRequestModel.importedCar === 1) ? "True" : "False",
      searchActualValue: (this.appointmentService.appointmentRequestModel.importedCar === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);

    if(this.isTireHotelActive){
      searchModel =
      {
        searchColumnName: "lblTireHotel",
        searchValue: (this.appointmentService.appointmentRequestModel.isTireHotel) ? "True" : "False",
        searchActualValue: (this.appointmentService.appointmentRequestModel.isTireHotel) ? "True" : "False",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.appointmentService.appointmentRequestModel.appointmentStatusId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblAppointmentStatus",
        searchValue: this.appointmentService.appointmentRequestModel.appointmentStatusId.toString(),
        searchActualValue: this.globalSetting.getAppointmentStatusName(this.appointmentService.appointmentRequestModel.appointmentStatusId)
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.workOrderStatusId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblWorkOrderStatus",
        searchValue: this.appointmentService.appointmentRequestModel.workOrderStatusId.toString(),
        searchActualValue: this.globalSetting.getWorkOrderStatus(this.appointmentService.appointmentRequestModel.workOrderStatusId)
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.licensePlate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblLicensePlate",
        searchValue: this.appointmentService.appointmentRequestModel.licensePlate.toString(),
        searchActualValue: this.appointmentService.appointmentRequestModel.licensePlate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.sourceOfCreation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSource",
        searchValue: this.selectedItems.map(x => x.text).join(','),
        searchActualValue: this.selectedItems.map(x => x.text).join(',')
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.appointmentService.appointmentRequestModel.woNumber) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblWoNo",
        searchValue: this.appointmentService.appointmentRequestModel.woNumber.toString(),
        searchActualValue: this.appointmentService.appointmentRequestModel.woNumber
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.appointmentType) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblAppointmenttype",
        searchValue: this.appointmentService.appointmentRequestModel.appointmentType.toString(),
        searchActualValue: this.appointmentService.appointmentRequestModel.appointmentType
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.documentPartStatus) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblDocumentPartStatus",
        searchValue: this.appointmentService.appointmentRequestModel.documentPartStatus,
        searchActualValue: this.appointmentService.appointmentRequestModel.documentPartStatus
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.customerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomer",
        searchValue: this.appointmentService.appointmentRequestModel.customerName.toString(),
        searchActualValue: this.appointmentService.appointmentRequestModel.customerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.mobileNumber) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblMobileNumber",
        searchValue: this.appointmentService.appointmentRequestModel.mobileNumber.toString(),
        searchActualValue: this.appointmentService.appointmentRequestModel.mobileNumber
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
    let createdDateFormatted= this.getFormattedDate(this.createdDate);
    searchModel= {
      searchColumnName: "lblBookedDateRange",
      searchValue: bookingDateFormatted,
      searchActualValue: bookingDateFormatted
    };
    this.saveSearchFilter.saveSearchArray.push(searchModel);
    searchModel =
    {
      searchColumnName: "lblCreatedDateRange",
      searchValue: createdDateFormatted,
      searchActualValue: createdDateFormatted
    };
    this.saveSearchFilter.saveSearchArray.push(searchModel);
    if (this.appointmentService.appointmentRequestModel.dealerId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSelectDealer",
        searchValue: this.appointmentService.appointmentRequestModel.dealerId.toString(),
        searchActualValue: this.dealerList.find(x => x.value === this.appointmentService.appointmentRequestModel.dealerId)?.text
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.serviceAdvisorSelected) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSelectServiceAdvisor",
        searchValue: this.serviceAdvisorSelected.toString(),
        searchActualValue: this.serviceAdvisorList.find(x => x.userId === this.serviceAdvisorSelected)?.userName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblServiceAdvisorAuthorized",
        searchValue: "True",
        searchActualValue: "True" 
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.mechanicSelected) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSelectMechanic",
        searchValue: this.mechanicSelected.toString(),
        searchActualValue: this.mechanics.find(x => x.id === this.mechanicSelected)?.name
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.brandCode) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblBrand",
        searchValue: this.appointmentService.appointmentRequestModel.brandCode,
        searchActualValue: this.appointmentService.appointmentRequestModel.brandCode
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.createdByUser) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCreatedBy",
        searchValue: this.selectedUser.map(x => x.value).join(','),
        searchActualValue: this.selectedUser.map(x => x.text).join(',')
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.isWarrantyAppointment) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblIsWarrantyAppointment",
        searchValue: this.appointmentService.appointmentRequestModel.isWarrantyAppointment? "True" : "False",
        searchActualValue: this.appointmentService.appointmentRequestModel.isWarrantyAppointment ? 'Yes' : 'No'
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.appointmentService.appointmentRequestModel.isWarrantyDocumentSigned != null) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblIsWarrantyDocumentSigned",
        searchValue: this.appointmentService.appointmentRequestModel.isWarrantyDocumentSigned? "True" : "False",
        searchActualValue: this.appointmentService.appointmentRequestModel.isWarrantyDocumentSigned ? "True" : "False"
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
  }

  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toastr.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toastr.success(successMsg);
        this.modalService.dismissAll();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toastr.error(errorMsg);
      }
    });
  }
  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalRef = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalRef.componentInstance.isFromAppointment = true;
      modalRef.componentInstance.searchList = this.savedSearchListResponse;
      modalRef.componentInstance.onReset.subscribe((_data) => {
        this.onResetSaveSearch();
      });
      modalRef.componentInstance.onEditOrRun.subscribe((data) => {
        if (!data.isRun) {
          this.onReset();
        }
        this.ApplySaveSearch(data.searchData, data.isRun);
      });
      modalRef.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data, modalRef);
      });
    });
  }

  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.Appointment).then(result => {
      if (result && !result.responseObject.errorCount) {
        this.savedSearchListResponse = result.responseObject;
        let dealerId: string;
        this.savedSearchListResponse.forEach(element => {
          element.saveSearchArray.forEach(async val => {
            const { searchColumnName, searchValue } = val;

            if (searchColumnName === 'lblAppointmentStatus') {
              val.searchActualValue = this.globalSetting.getAppointmentStatusName(+searchValue);
            } else if (searchColumnName === 'lblWorkOrderStatus') {
              val.searchActualValue = this.globalSetting.getWorkOrderStatus(+searchValue);
            } else if (searchColumnName === 'lblSelectDealer') {
              dealerId = searchValue;
              const dealer = this.dealerList.find(x => x.value === searchValue);
              val.searchActualValue = dealer?.text || searchValue;
            } else if (searchColumnName === 'lblCreatedBy') {
              let searchActualValue = "";
              const sourceStr = searchValue.split(",");
              if (this.UserList && sourceStr) {
                this.UserList.forEach(x => {
                  sourceStr.forEach(y => {
                    if (x.value === y) {
                      searchActualValue = searchActualValue.concat(",", x.text);
                    }
                  });
                });
              }
              val.searchActualValue = searchActualValue;
            } 
            else if (searchColumnName === 'lblSelectServiceAdvisor') {
              await this.appointmentCommonService.getServiceAdvisorDetails(dealerId);
              this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
              const serviceAdvisor = this.serviceAdvisorList.find(x => x.userId.toString() === searchValue);
              val.searchActualValue = serviceAdvisor?.userName || searchValue;
            }
            else if (searchColumnName === 'lblSelectMechanic') {
              this.dealerId = dealerId;
              await this.getAllMechanics();
              const mechanic = this.mechanics.find(x => x.id.toString() === searchValue);
              val.searchActualValue = mechanic?.name || searchValue;
            }
            else {
              val.searchActualValue = searchValue;
            }
          });
        });
      }

      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  processSavedSearchList(responseObject) {
    this.savedSearchListResponse = responseObject;

    this.savedSearchListResponse.forEach(element => {
      element.saveSearchArray.forEach(val => {
        this.processSearchColumn(val);
      });
    });
  }

  processSearchColumn(val) {
    const { searchColumnName, searchValue } = val;

    if (searchColumnName === 'lblAppointmentStatus') {
      val.searchActualValue = this.globalSetting.getAppointmentStatusName(+searchValue);
    } else if (searchColumnName === 'lblWorkOrderStatus') {
      val.searchActualValue = this.globalSetting.getWorkOrderStatus(+searchValue);
    } else if (searchColumnName === 'lblSelectDealer') {
      val.searchActualValue = this.getDealerText(searchValue);
    } else if (searchColumnName === 'lblCreatedBy') {
      val.searchActualValue = this.getCreatedByText(searchValue);
    } else {
      val.searchActualValue = searchValue;
    }
  }

  getDealerText(searchValue) {
    const dealer = this.dealerList.find(x => x.value === searchValue);
    return dealer?.text || searchValue;
  }

  getCreatedByText(searchValue) {
    let searchActualValue = "";
    const sourceStr = searchValue.split(",");

    if (this.UserList && sourceStr) {
      this.UserList.forEach(x => {
        sourceStr.forEach(y => {
          if (x.value === y) {
            searchActualValue = searchActualValue.concat(",", x.text);
          }
        });
      });
    }

    return searchActualValue;
  }

  OnDeleteSaveSearch(searchName, outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSavedFilters"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(() => outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toastr.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toastr.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toastr.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }

        });
      }
    });
  }
  SearchValues(searchValue) {
    if (searchValue === "True") {
      return 1;
    } else if (searchValue === "False") {
      return 0;
    } else {
      return 2;
    }
  }

  ApplySaveSearch(data, isRunSearch) {
    if (!data) {
      return;
    }

    this.saveSearchDetail = this.savedSearchListResponse.find(x => x.filterName === data);

    if (!this.saveSearchDetail) {
      return;
    }

    this.saveSearchDetail.saveSearchArray.forEach(async element => {
      await this.applySearchElement(element);
    });

    if (isRunSearch) {
      this.isFilterApplied = true;
      this.AdvanceSearchSubmit();
    } else {
      this.onSearch();
    }
  }

  async applySearchElement(element) {
    switch (element.searchColumnName) {
      case 'lblIsRentalCar':
        this.appointmentService.appointmentRequestModel.isRentalCar = this.parseSearchValue(element.searchValue);
        this.isRentalCar = this.parseBooleanSearchValue(element.searchValue);
        break;
      case 'lblTireHotel':
        this.appointmentService.appointmentRequestModel.isTireHotel = this.parseSearchValue(element.searchValue);
        this.isTireHotel = this.parseBooleanSearchValue(element.searchValue);
        break;
      case 'lblCurrentOffer':
        this.appointmentService.appointmentRequestModel.currentOffer = this.parseSearchValue(element.searchValue);
        this.currentOffer = this.parseBooleanSearchValue(element.searchValue);
        break;
      case 'lblCustomerWaiting':
        const parsedValue = this.parseSearchValue(element.searchValue);
        this.appointmentService.appointmentRequestModel.customerWaiting = parsedValue ? 1 : 0;
        this.isCustomerWaiting = parsedValue;
        break;
      case 'lblCampaignService':
        const isCampaign = element.searchValue === 'True' ? true : element.searchValue === 'False' ? false : element.searchValue;
        this.appointmentService.appointmentRequestModel.isCampaignService = isCampaign ? 1 : 0;
        this.isCampaignService = isCampaign;
        break;
      case 'lblAppointmentStatus':
        this.appointmentService.appointmentRequestModel.appointmentStatusId = +element.searchValue;
        break;
      case 'lblWorkOrderStatus':
        this.appointmentService.appointmentRequestModel.workOrderStatusId = +element.searchValue;
        break;
      case 'lblLicensePlate':
        this.appointmentService.appointmentRequestModel.licensePlate = element.searchValue;
        break;
      case 'lblWoNo':
        this.appointmentService.appointmentRequestModel.woNumber = element.searchValue;
        break;
      case 'lblAppointmenttype':
        this.appointmentService.appointmentRequestModel.appointmentType = element.searchValue;
        break;
      case 'lblDocumentPartStatus':
        this.appointmentService.appointmentRequestModel.documentPartStatus = element.searchValue;
        break;
      case 'lblNeedAttention':
        this.appointmentService.appointmentRequestModel.needAttention = (element.searchValue === "1") ? 1 : 0;
        this.needAttention = (element.searchValue === "1") ? 1 : 0;
        break;
      case 'lblCustomer':
        this.appointmentService.appointmentRequestModel.customerName = element.searchValue;
        break;
      case 'lblMobileNumber':
        this.appointmentService.appointmentRequestModel.mobileNumber = element.searchValue;
        break;
      case 'lblBrand':
        this.appointmentService.appointmentRequestModel.brandCode = element.searchValue;
        break;
      case 'lblBookedDateRange':
        let dateValue = element.searchValue.split("-");
        if (dateValue.length > 1) {
          let startDateParts = dateValue[0].trim().split("/");
          let startDate = new Date(+startDateParts[2], +startDateParts[1] - 1, +startDateParts[0]);
          let endDateParts = dateValue[1].trim().split("/");
          let endDate = new Date(+endDateParts[2], +endDateParts[1] - 1, +endDateParts[0]);
          this.bookingDate = [];
          this.bookingDate.push(startDate);
          this.bookingDate.push(endDate);
        }
        break;
      case 'lblCreatedDateRange':
        let createdDateValue = element.searchValue.split("-");
        if (createdDateValue.length > 1) {
          let createdStartDateParts = createdDateValue[0].trim().split("/");
          let createdStartDate = new Date(+createdStartDateParts[2], +createdStartDateParts[1] - 1, +createdStartDateParts[0]);
          let createdEndDateParts = createdDateValue[1].trim().split("/");
          let createdEndDate = new Date(+createdEndDateParts[2], +createdEndDateParts[1] - 1, +createdEndDateParts[0]);
          this.createdDate = [];
          this.createdDate.push(createdStartDate);
          this.createdDate.push(createdEndDate);
        }
        break;
      case 'lblSelectDealer':
        await this.onDealerSelected(element.searchValue, 'advanceSearchDealerDropdown');
        break;
      case 'lblSelectServiceAdvisor':
        if (!this.serviceAdvisorList || this.serviceAdvisorList.length === 0) {
          await this.appointmentCommonService.getServiceAdvisorDetails(this.dealerId);
          this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
        }
        if (this.serviceAdvisorList && this.serviceAdvisorList.length > 0) {
          this.serviceAdvisorSelected = element.searchValue;
          this.appointmentService.appointmentRequestModel.serviceAdvisorId = element.searchValue;
        }
        break;
      case 'lblServiceAdvisorAuthorized':
        this.appointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = element.searchValue === "True";
        break;
      case 'lblSelectMechanic':
        if (!this.mechanics || this.mechanics.length === 0) {
          await this.getAllMechanics();
        }
        if (this.mechanics && this.mechanics.length > 0) {
          const mechanicId = Number(element.searchValue);
          this.mechanicSelected = (mechanicId as any);
          this.appointmentService.appointmentRequestModel.mechanicId = element.searchValue;
        }
        break;
      case 'lblCreatedBy':
        this.handleCreatedBy(element, this.UserList)
        break;
      case 'lblSource':
        this.handleSource(element, this.applicationSourceList)
        break;
      default:
        break;
    }
  }
  handleCreatedBy(element, userList) {
    this.appointmentService.appointmentRequestModel.createdByUser = element.searchValue.split(",").join(',');

    const sourceCreatedByStr = element.searchValue.split(",");
    if (userList && sourceCreatedByStr) {
      sourceCreatedByStr.forEach(y => {
        const matchingUser = userList.find(x => x.value === y);
        if (matchingUser) {
          this.selectedUser.push(matchingUser);
        }
      });
    }
  }
  handleSource(element, sourceList) {
    const sourceStr = element.searchValue.split(",");
    if (sourceList && sourceStr) {
      sourceStr.forEach(y => {
        const matchingSource = sourceList.find(x => x.text === y);
        if (matchingSource) {
          this.selectedItems.push(matchingSource);
        }
      });
    }

    this.appointmentService.appointmentRequestModel.sourceOfCreation = this.selectedItems.map(x => x.value).join(',');
  }

  parseSearchValue(value) {
    return value === 'True' || value === 'False' ? this.parseBooleanSearchValue(value) : value;
  }

  parseBooleanSearchValue(value) {
    return value === 'True';
  }


  viewException(id: number) {
    this.dmsLogRequestModel.referenceId = id;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
            // This is intentional

          }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
          });
        } else {
          this.toastr.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }
  onSyncToDms(id, appointmentGuid) {
    this.spinner.show();
    this.appointmentService.IsLockedByOtherUser(appointmentGuid).then((res) => {
      const locked = res.responseObject;
      if (locked?.isLocked && this.editAppointmentService.isLockFeatureEnabled) {
        let modelHeadermsg = this.translate.instant('lblAppointmentLocked');
        let modelBodymsg = this.translate.instant('lblUsedByAnotherUser');
        modelBodymsg = modelBodymsg.replace('##USER##', locked.lockedByName);
        this.isOpenByOtherUser = true;
        const updatedModalRef = this.modalService.open(NgInfoModalContent);
        updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
        updatedModalRef.componentInstance.modelBody = modelBodymsg;
      } else {
        this.editAppointmentService.isOpenByOtherUser = false;
        let modelHeadermsg = this.translate.instant("lblSyncToDMS");
        let modelBodymsg = this.translate.instant("lblSureToSync");
        let errorMsg = this.translate.instant('lblErrormsg');
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
          // This is intentional
        }, (reason) => {
          this.popupCloseResult = this.getDismissReason(reason);
          if (this.popupCloseResult) {
            this.spinner.show();
            this.appointmentService.ResyncAppointment(id, Enums.ModuleNames.Appointment).then((response) => {
              this.spinner.hide();
              if (response.responseObject.isSuccess) {
                let successMsg = this.translate.instant('lblSyncSuccess')
                this.toastr.success(successMsg);
                this.appointmentList = [];
                this.appointmentService.appointmentRequestModel.startRecordNumber = 0;
                this.GetAppointmentList(this.appointmentService.appointmentRequestModel);
              } else {
                this.spinner.hide();
                this.toastr.error(errorMsg);
              }
            });
          }
        });
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  OpenEditView(appointment: any) {
    if (this.userRoleRightsDetails.canEdit) {
      if (appointment.isEditable) {
        this.onEdit(appointment);
      }
      else if (!appointment.isEditable) {
        this.onView(appointment);
      }
    }
  }
  //#region Edit Appointment Notification
  IsLockedByOtherUser(appointment: any) {
    if (this.editAppointmentService.isLockFeatureEnabled) {
      this.appointmentService.IsLockedByOtherUser(appointment.appointmentGuid).then((res) => {
        const locked = res.responseObject;
        if (locked?.isLocked) {
          let modelBodymsg = this.translate.instant('lblUsedByAnotherUser');
          modelBodymsg = modelBodymsg.replace('##USER##', locked.lockedByName);
          this.isOpenByOtherUser = true;
          this.isOpenByOtherUserMsg = modelBodymsg;
        }
        else {
          this.isOpenByOtherUser = false;
        }
      });
    } else {
      this.isOpenByOtherUser = false;
    }
  }
  //#endregion

  setUnRepliedWhatsAppMessagesFilter() {
    const isReplied = this.whatsAppLogService.getUnrepliedMessageFilter();
    if (isReplied == true) {
     this.isFilterUnRepliedMessages = isReplied;
    }
    else {
      this.isFilterUnRepliedMessages = false;
    }
  }

  convertToDate(dateString)
  {
    const parts = dateString.split('/');
    const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
    const date = new Date(formattedDate);
    return date;
  }
  
  openWhatsAppMessagesTab(appointment: any) {
    this.multiStackPopupService.OpenAppointment(appointment.id, true);
  }

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datepipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datepipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }

  getSelectedServiceAdvisorName(): string {
    if (!this.serviceAdvisorSelected || !this.serviceAdvisorList?.length) {
      return '';
    }

    return this.serviceAdvisorList.find(x => x.userId === this.serviceAdvisorSelected)?.userName || '';
  }

  async getAllMechanics(): Promise<void> {
    await this.mechanicService.GetMechanicList(this.dealerId, Enums.StatusCode.Active).then((response) => {
      this.mechanics = response.responseObject
    });
  }
}
